import * as types from './mutation-types'
export default {
  [types.SAVE_ALL_APPRAISALS](state, data) {
    console.log('mutation ', data)
    state.allAppraisals = data
  },
}
